import React, { FC, useRef, useEffect } from "react";
import ReactDOM from "react-dom";

const modalRoot = document.getElementById("modal-root");

function generateHolderElement() {
  const el = document.createElement("section");
  el.style.width = "inherit";
  el.style.height = "100%";
  el.style.position = "fixed";
  el.style.top = "0px";
  el.style.zIndex = "500";
  return el;
}

// Let's create a Modal component that is an abstraction around
// the portal API.
const Modal: FC = ({ children }) => {
  // Create a div that we'll render the modal into. Because each
  // Modal component has its own element, we can render multiple
  // modal components into the modal container.
  const el = useRef(generateHolderElement());

  useEffect(() => {
    // Append the element into the DOM on mount. We'll render
    // into the modal container element (see the HTML tab).
    modalRoot && modalRoot.appendChild(el.current);
    return function unmountingModal() {
      // Remove the element from the DOM when we unmount
      modalRoot && modalRoot.removeChild(el.current);
    };
  }, [el]);

  // Use a portal to render the children into the element
  return ReactDOM.createPortal(
    // Any valid React child: JSX, strings, arrays, etc.
    children,
    // A DOM element
    el.current
  );
};

export default Modal;
